export default __webpack_public_path__ + "static/media/instagram.a3cce97c.svg";